module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b-modal', {
    ref: "modalConfirm",
    attrs: {
      "id": "modalConfirm",
      "title": "Confirm",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.onclick
    },
    model: {
      value: (_vm.showmodal),
      callback: function($$v) {
        _vm.showmodal = $$v
      },
      expression: "showmodal"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-790382b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/confirm.vue
// module id = 248
// module chunks = 1